import {
  IconChecklist,
  IconClipboardList,
  IconDashboard,
  IconFileText,
  IconFiles,
  IconListDetails,
  IconMap,
  IconTargetArrow,
  IconUsers,
} from '@tabler/icons-react';
import type { ComponentType } from 'react';

/**
 * Per-app SideNav item. Plain `.ts` (no JSX) so icons are carried as
 * component references, not pre-built elements — SideNav renders
 * `<item.icon size={18} />` itself.
 */
export interface NavItem {
  to: string;
  label: string;
  icon: ComponentType<{ size?: number }>;
  /** If true, renders a "Coming soon" disabled item. */
  comingSoon?: boolean;
}

/**
 * Nav items keyed by `apps.key` (snake_case). Targets are namespaced under
 * `/a/<slug>/...` (see app-slug.ts). The Admin item is deliberately NOT part
 * of this map — it isn't scoped to any one app; SideNav renders it
 * separately, gated on system_role, same as before namespacing.
 */
export const NAV_BY_APP: Record<string, NavItem[]> = {
  running_title: [
    { to: '/a/running-title', label: 'Dashboard', icon: IconDashboard },
    { to: '/a/running-title/tracts', label: 'Tracts', icon: IconMap },
    { to: '/a/running-title/title-runs', label: 'Title Runs', icon: IconListDetails },
    { to: '/a/running-title/parties', label: 'Parties', icon: IconUsers },
    { to: '/a/running-title/prospects', label: 'Prospects', icon: IconTargetArrow },
    { to: '/a/running-title/contracts', label: 'Contracts', icon: IconFileText },
    { to: '/a/running-title/documents', label: 'Documents', icon: IconFiles },
    {
      to: '/a/running-title/requirements',
      label: 'Requirements',
      icon: IconChecklist,
      comingSoon: true,
    },
  ],
  land_data: [
    { to: '/a/land-data/lease', label: 'Lease', icon: IconFileText },
    { to: '/a/land-data/contracts', label: 'Contracts', icon: IconFileText },
    { to: '/a/land-data/wells', label: 'Wells', icon: IconMap },
    { to: '/a/land-data/obligations', label: 'Obligations', icon: IconClipboardList },
  ],
};
